import { faChartPieSimple } from '@fortawesome/pro-solid-svg-icons';
import { Box, Chip, Divider, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Fragment } from 'react';

import { Coins } from '../../assets/svg/Coins';
import Icon from '../../components/Icon/Icon';
import { useConsolidationTexts } from '../../hooks/useConsolidationTexts';
import useTranslation from '../../hooks/useTranslation';
import { Consolidation } from '../../types/ConsolidationTypes';
import { ListItemStyles, ListItemTextStyles } from './ConsolidationList.styles';

type ConsolidationsListProps = {
    consolidations: Consolidation[];
};

const ConsolidationsList = ({ consolidations }: ConsolidationsListProps) => {
    const translate = useTranslation();
    const { getTitle, getCaption } = useConsolidationTexts();

    if (consolidations.length === 0) {
        return undefined;
    }

    return (
        <List>
            {consolidations.map((consolidation) => (
                <Fragment key={consolidation.internalId}>
                    <ListItem sx={ListItemStyles}>
                        {consolidation.consolidationType === 'PARTIAL' && (
                            <Chip
                                label={translate('field.partial-consolidation.label')}
                                color="info"
                                sx={{ mb: 1, mt: 1 }}
                            />
                        )}
                        <Box sx={ListItemTextStyles}>
                            <ListItemIcon>
                                {consolidation.consolidationType === 'PARTIAL' ? (
                                    <Icon icon={faChartPieSimple} />
                                ) : (
                                    <Coins hideBackground={true} />
                                )}
                            </ListItemIcon>
                            <ListItemText
                                primary={<Typography>{getTitle(consolidation)}</Typography>}
                                secondary={
                                    <Typography variant="caption" color="text.secondary">
                                        {getCaption(consolidation)}
                                    </Typography>
                                }
                            />
                        </Box>
                    </ListItem>
                    <Divider component="li" />
                </Fragment>
            ))}
        </List>
    );
};

export default ConsolidationsList;
